import AdminPrivateNotes from "@/pages/admin/AdminPrivateNotes";

export default function VendorNotes() {
  return <div data-testid="vendor-notes-page"><AdminPrivateNotes /></div>;
}
